import { IAttribute, IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Activity } from './activity';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { format } from '../../shared/utils/string.util';
import { ParameterValue } from '../base/parameter-value';
import { LinkedService } from '../linkedservice/linkedservice';
import { DataBuildToolJobLinkedService } from '../linkedservice/data-build-tool-job.linkedservice';
@Metamodel.model({
    name: ModelConstants.invokeDataBuildToolJob,
    referable: true
})
export class InvokeDataBuildToolJobActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly DATABUILDTOOLJOBID: IAttribute;
    public static readonly WORKSPACEID: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;
    public static readonly OPERATION: IAttribute;
    public static readonly SELECT: IAttribute;
    public static readonly EXCLUDE: IAttribute;
    public static readonly FULLREFRESH: IAttribute;
    public static readonly FAILFAST: IAttribute;
    public static readonly THREADS: IAttribute;
    public static readonly SELECTORNAME: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ConnectionLabel,
        reference: true,
        type: DataBuildToolJobLinkedService.MODEL,
        constraint: {
            validator: InvokeDataBuildToolJobActivity.validateConnection
        }
    })
    public dataBuildToolJobLinkedService: DataBuildToolJobLinkedService;

    @Metamodel.attribute({
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters?: ParameterValue[] = [];

    @Metamodel.attribute({
        display: shellStringResources.DataBuildToolJobIdLabel,
        association: 'DATABUILDTOOLJOBID',
        constraint: {
            validator: InvokeDataBuildToolJobActivity.validateDataBuildToolJob
        },
        templatable: true
    })
    public dataBuildToolJobId: string;

    @Metamodel.attribute({
        display: shellStringResources.TridentWorkspaceLabel,
        association: 'WORKSPACEID',
        constraint: {
            validator: InvokeDataBuildToolJobActivity.validateWorkspace
        },
        templatable: true
    })
    public workspaceId: string;

    @Metamodel.attribute({
        association: 'OPERATION',
        templatable: true
    })
    public operation?: string;

    @Metamodel.attribute({
        association: 'SELECT',
        templatable: true
    })
    public select?: string;

    @Metamodel.attribute({
        association: 'EXCLUDE',
        templatable: true
    })
    public exclude?: string;

    @Metamodel.attribute({
        association: 'FULLREFRESH'
    })
    public fullRefresh?: boolean;

    @Metamodel.attribute({
        association: 'FAILFAST'
    })
    public failFast?: boolean;

    @Metamodel.attribute({
        association: 'THREADS',
        templatable: true
    })
    public threads?: number;

    @Metamodel.attribute({
        association: 'SELECTORNAME',
        templatable: true
    })
    public selectorName?: string;

    private static validateDataBuildToolJob(_invokeDataBuildToolJobActivity?: InvokeDataBuildToolJobActivity, value?: string): IViolation[] | undefined {
        if (!value) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.DataBuildToolJobLabel)
                }
            ];
        }
        return undefined;
    }

    private static validateWorkspace(_invokeDataBuildToolJobActivity?: InvokeDataBuildToolJobActivity, value?: string): IViolation[] | undefined {
        if (!value) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.TridentWorkspaceLabel)
                }
            ];
        }
        return undefined;
    }

    private static validateConnection(_invokeDataBuildToolJobActivity?: InvokeDataBuildToolJobActivity, linkedService?: LinkedService): IViolation[] | undefined {
        if (!linkedService) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.ConnectionLabel)
                }
            ];
        } else if (linkedService && linkedService.getLinkedServiceType() != Metamodel.modelFor(DataBuildToolJobLinkedService).name) {
            return [
                {
                    message: () =>
                        format(
                            shellStringResources.ActivityNotSupportLinkedServiceError,
                            format(shellStringResources.ModelName_ActivityTemplate, shellStringResources.DataBuildToolJobLabel),
                            format(shellStringResources.ModelName_ConnectionTemplate, Metamodel.modelOf(linkedService).name)
                        ),
                    messageType: 'unsupported'
                }
            ];
        }
        return undefined;
    }
}
